module.exports = __webpack_public_path__ + "img/Live_icon.e6276ed4.svg";